module.exports = __webpack_public_path__ + "static/testimonial-thumb-5-58796b71cb8586ff050379001e0207b2.jpg";